import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import agentPackageBiz from "../../biz/agentPackageBiz"

const initialState = {
    packages: []
}

export const fetchPackage = createAsyncThunk('package/fetchPackage', async () => {
    const result = await agentPackageBiz.search();
    
    return result;
})

const packageSlice = createSlice({
    name: 'package',
    initialState,
    reducers: {},
    extraReducers(builder) {
        builder
            .addCase(fetchPackage.fulfilled, (state, action) => {
                state.packages = action.payload;
            })
    }
})

export const getAllPackages = state => state.package.packages; //export selector
export const getPckgById = (state, id) => {
    return getAllPackages(state).find(pckg => pckg._id === id) || {};
}; 

export default packageSlice.reducer;